// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentResponseModel {
    static getAttributeTypeMap() {
        return EnrollmentResponseModel.attributeTypeMap;
    }
}
EnrollmentResponseModel.discriminator = undefined;
EnrollmentResponseModel.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=enrollmentResponseModel.js.map